import styled from 'styled-components'

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: #222;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url('/img/empty_class.png') center center no-repeat;
    background-size: contain;
`

export const Overlay = styled.div`
    width: 100%;
    height: 35%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 25%;
    text-align: center;
    color: white;
    font-size: 24px;
    line-height: 30px;
    font-family: AvenirBold;
`
